import React from "react";
import { Smartphone, ShoppingBag, Utensils, Laptop, Palette, Stethoscope, Briefcase, Shirt } from "lucide-react";

const IndustriesServed = () => {
  const industries = [
    {
      icon: <Laptop />,
      name: "Technology & Software",
      description: "Protect your tech innovations, app names, and digital products with comprehensive trademark coverage.",
    },
    {
      icon: <ShoppingBag />,
      name: "E-Commerce & Retail",
      description: "Secure your online store brand, product lines, and retail identity across all channels.",
    },
    {
      icon: <Shirt />,
      name: "Fashion & Apparel",
      description: "Register clothing brands, designer labels, and fashion accessories with expert guidance.",
    },
    {
      icon: <Utensils />,
      name: "Food & Beverage",
      description: "Trademark your restaurant names, food products, recipes, and culinary brands.",
    },
    {
      icon: <Stethoscope />,
      name: "Healthcare & Wellness",
      description: "Protect medical brands, wellness products, and healthcare service names.",
    },
    {
      icon: <Palette />,
      name: "Creative & Design",
      description: "Safeguard your creative agency, design studio, or artistic brand identity.",
    },
    {
      icon: <Briefcase />,
      name: "Professional Services",
      description: "Register consulting firms, legal practices, and B2B service brands.",
    },
    {
      icon: <Smartphone />,
      name: "Apps & Digital Products",
      description: "Secure mobile apps, SaaS platforms, and digital service trademarks.",
    },
  ];

  return (
    <section id="industries" className="industries-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Industries We Serve</h2>
          <p className="section-subtitle">
            Expert Trademark Protection Across All Business Sectors
          </p>
        </div>

        <div className="industries-intro-card">
          <p className="industries-intro-text">
            No matter what industry you're in, your brand deserves protection. Our trademark registration expertise spans across diverse sectors, helping businesses of all types and sizes secure their intellectual property. From startups to established enterprises, we understand the unique trademark needs of each industry.
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="industry-icon">{industry.icon}</div>
              <h4 className="industry-name">{industry.name}</h4>
              <p className="industry-description">{industry.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesServed;
